module.exports = __webpack_public_path__ + "media/volvo/assets/images/volvo_v40@2x-62c438921677ee4d5406c1ea32601249.png";